import React, { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AsideDefault } from '../../../assets/layout/components/aside/AsideDefault'
import { Toolbar } from '../../../components/Toolbar'

import Header from '../../../components/Header'
import { MenuComponent } from '../../../assets/ts/components'

const DefaultLayout: React.FC = ({ children }) => {
  const location = useLocation()
  useLayoutEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useLayoutEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])
  return (
    <div className="page d-flex flex-row flex-column-fluid">
      <AsideDefault />
      <div
        className="wrapper d-flex flex-column flex-row-fluid"
        id="kt_wrapper"
      >
        <Header />

        <div
          id="kt_content"
          className="content d-flex flex-column flex-column-fluid"
        >
          <Toolbar />
          <div className="post d-flex flex-column-fluid" id="kt_post">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout
